import { getButtonFocusOverrideStyle } from './common-styles';

export const getWaterfallFilterStyles = (waterFallFilter, { palette = {} }) => ({
  divider: {
    borderTop: `solid 1px ${palette.mainMenuHoverBackground}`,
  },
  waterFall: {
    height: '36px',
    width: '100%',
  },
  description: {
    width: '179px',
    display: 'inline-block',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '17px',
    fontSize: '12px',
    verticalAlign: 'top',
    color: palette.white,
  },
  toggleMenu: {
    width: '47px',
    height: '100%',
    display: 'inline-block',
    position: 'relative',
  },
  toggleButton: {
    width: '47px',
    height: '100%',
    minWidth: 0,
    padding: '11px 16px',
    background: `${palette.neutralPrimaryAlt} !important`,
    '&:focus': getButtonFocusOverrideStyle(palette.neutralSecondary),
    '&:hover': {
      backgroundColor: `${palette.mainMenuHoverBackground} !important`,
    },
  },
  toggleGlyphicon: {
    color: palette.white,
    width: '16px',
    height: '14px',
    top: '0 !important',
    margin: '0 !important',
  },
  dropdown: {
    position: 'absolute',
    width: '180px',
    top: '100%',
    left: 0,
  },
});
